import { useQuery } from '@tanstack/react-query';
import { Group, Member, PreRegistration, Site, page } from '@cloudsign/shared';
import type { PreRegistrationStatus } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../lib/api';

export const PreRegistrationPage = page(PreRegistration);
export const PreRegistrationList = z.array(PreRegistration);
const SitePage = page(Site);
const GroupList = z.array(Group);
const MemberPage = page(Member);

export const STATUS_TABS: (PreRegistrationStatus | 'all')[] = ['all', 'expected', 'pending_approval', 'arrived', 'no_show', 'cancelled'];

export const preKey = ['pre-registration'] as const;

export function useAllSites() {
  return useQuery({ queryKey: ['prereg', 'sites'], queryFn: () => api.get('/sites', { query: { status: 'all', pageSize: 200 }, schema: SitePage }) });
}

export function useActiveGroups() {
  return useQuery({ queryKey: ['prereg', 'groups'], queryFn: () => api.get('/groups', { query: { status: 'active' }, schema: GroupList }) });
}

/** Members of one group, to pick a host from. */
export function useGroupMembers(groupId: string) {
  return useQuery({
    queryKey: ['prereg', 'members', groupId],
    enabled: groupId !== '',
    queryFn: () => api.get('/members', { query: { groupId, status: 'current', pageSize: 200 }, schema: MemberPage }),
  });
}

/** Uploads an email attachment for a group (pre-registration) or members group (onboarding). Returns the stored file id. */
export async function uploadAttachment(path: string, groupId: string, file: File): Promise<string> {
  const form = new FormData();
  form.set('groupId', groupId);
  form.set('file', file);
  const r = await api.post(path, { form, schema: z.object({ fileId: z.uuid() }) });
  return r.fileId;
}
